import React, { useEffect, useState } from "react";
import "../App.css";
import { auth, db } from "../firebase";
import {
  collection,
  query,
  where,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  updateDoc
} from "firebase/firestore";

function Header() {

  const [pendingCount, setPendingCount] = useState(0);
  const [propertyId, setPropertyId] = useState(null);
  const [kotPrinter, setKotPrinter] = useState("");

  // ✅ 1️⃣ Load propertyId from authroles
  useEffect(() => {
    const loadUserProperty = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const roleSnap = await getDoc(doc(db, "authroles", user.uid));
      if (!roleSnap.exists()) return;

      const data = roleSnap.data();
      setPropertyId(data.propertyId);
    };

    loadUserProperty();
  }, []);

  // ✅ 2️⃣ Load Printer Settings
  useEffect(() => {
    if (!propertyId) return;

    const loadPrinter = async () => {
      const q = query(
        collection(db, "printerSettings"),
        where("propertyId", "==", propertyId)
      );

      const snap = await getDocs(q);
      if (!snap.empty) {
        const data = snap.docs[0].data();
        setKotPrinter(data.kotPrinter || "");
      }
    };

    loadPrinter();
  }, [propertyId]);

  // ✅ 3️⃣ Real-Time Print Listener
  useEffect(() => {
    if (!propertyId || !kotPrinter) return;

    const q = query(
      collection(db, "pendingkot"),
      where("propertyId", "==", propertyId),
      where("status", "==", "PENDING")
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {

      setPendingCount(snapshot.size);

      snapshot.docChanges().forEach(async (change) => {

        if (change.type === "added") {

          const docId = change.doc.id;
          const data = change.doc.data();

          try {
            console.log("🖨 Printing KOT:", data);

            // ✅ Direct Print using Electron
            await window.electronAPI?.silentPrint(
              data.html,
              data.printer || kotPrinter
            );

            // ✅ Mark as PRINTED
            await updateDoc(doc(db, "pendingkot", docId), {
              status: "PRINTED",
              printedAt: new Date()
            });

          } catch (error) {
            console.error("Print Failed:", error);

            await updateDoc(doc(db, "pendingkot", docId), {
              status: "FAILED"
            });
          }
        }

      });

    });

    return () => unsubscribe();

  }, [propertyId, kotPrinter]);

  const signOut = () => {
    auth.signOut();
    window.location.href = "/login";
  };

  const toggleSidebar = () => {
    document.body.classList.toggle("sidebar-collapse");
    document.body.classList.toggle("sidebar-open");
  };

  return (
    <nav className="main-header navbar navbar-expand header-modern">

      {/* LEFT */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link header-icon" href="#0" onClick={toggleSidebar}>
            <i className="fas fa-bars" />
          </a>
        </li>

        <li className="nav-item d-flex align-items-center">
          <span className="header-title text-uppercase">Reszio</span>
        </li>
      </ul>

      {/* RIGHT */}
      <ul className="navbar-nav ml-auto align-items-center">

        <li className="nav-item">
          <a
            className="nav-link header-icon"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
          >
            <i className="fas fa-sync"></i>
          </a>
        </li>

         <li className="nav-item">
          <a className="nav-link header-icon" href="javascript:history.go(-1)">
            <i className="fas fa-arrow-left" />
          </a>
        </li>

        <li className="nav-item">
          <a className="nav-link header-icon" href="javascript:history.go(1)">
            <i className="fas fa-arrow-right" />
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link header-icon logout-btn"
            href="#0"
            onClick={signOut}
          >
            <i className="fas fa-sign-out-alt" />
          </a>
        </li>

      </ul>
    </nav>
  );
}

export default Header;